//#region import
import React, { Fragment, createContext, useEffect, useMemo, useState } from 'react';
import { Fab, Grid, Typography, Zoom, useScrollTrigger } from '@mui/material';
import { ApiProject } from 'enum/api';
import { APIStatusCode, EnumLogHistoryMode, EnumProjectStatusID, EnumRegisterTimelineType, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { Convert, FnAxios, FnDialog, I18n, RouterDOM } from 'utilities/utilities';
import LogHistory from './components/History/LogHistory';
import { BtnBack, BtnComment, BtnDes, BtnDownload, BtnDraft, BtnEdit, BtnPreviewForm, BtnPrint, BtnReject, BtnSend } from 'components/Button/ButtonAll';
import Tabs, { TabContent, TabItem, TabPanel } from 'components/Input/Tab';
import RequestPanel from './RequestKth1/RequestPanel';
import RequestPlan from './RequestKth2/RequestPlan';
import StepperProject from "./components/Stepper";
import ModalReadyPresent from './components/Modal/ModalReadyPresent';
import ProjectScoringCriteria from './ScoringCriteria/ProjectScoringCriteria';
import ProjectScoreSummary from './ScoreSummary/ProjectScoreSummary';
import ProjectRecordResolution from './ResultLetter/ProjectResultLetter';
import ModalProjectCancel from './components/Modal/ModalProjectCancel';
import { FormProvider, useForm } from 'react-hook-form';
import { SelectItem } from 'components/Input/Select/SelectItem';
import ProjectChangeStatus from './VersionChangeStatus/ProjectChangeStatus';
import Present403 from './PresentPortfolio/Present403';
import Present404 from './PresentPortfolio/Present404';
import CloseProject from './RequestKth3/RequestKth32/CloseProject';
import UpdateProgressPlan from './RequestKth3/RequestKth31/UpdateProgressPlan';
import { HiOutlineArrowNarrowUp } from 'react-icons/hi';

//#endregion

const ProjectContext = createContext(null);
const ProjectRequestFrom = () => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const navigate = useNavigate();
    const location = useLocation();
    const Router = RouterDOM();

    //#region useState
    const sBackgroundTab = "rgb(17 56 120)";
    const sBackgroundTabActive = "linear-gradient(rgb(77 110 197) 33%, rgb(101 158 221 / 57%) 71%, rgb(184 209 255 / 68%) 87%, rgb(255, 255, 255) 100%)";

    const [isSend, setisSend] = useState(true);
    const [isFastTrack, setisFastTrack] = useState(false); // true แบบเร่งด่วน | false แบบปกติ
    const [isPermission, setisPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [nProjectID, setnProjectID] = useState(0);
    const [sMode, setsMode] = useState(null);
    const [nStatusID, setnStatusID] = useState(null); //TbProject.nStatusID
    const [nProgressStatusID, setnProgressStatusID] = useState(null); //TbProject.nProgressStatusID
    const [nStatusUpdateProgressID, setnStatusUpdateProgressID] = useState(null); //TprojectUpdateProgress.nStatus

    const [isRequester, setisRequester] = useState(false); //คนสร้าง
    const [isSecretary, setisSecretary] = useState(false); //เลขา
    // const [isSubCommittee, setisSubCommittee] = useState(false); //อนุกรรมการ
    const [ObjStepFlowProject, setObjStepFlowProject] = useState(null); //ข้อมูล Step Flow Project

    const [isGetFromID, setisGetFromID] = useState(false);
    const [ObjProjectRequest, setObjProjectRequest] = useState<any>([]);
    const [arrisEditPanel, setarrisEditPanel] = useState([]);  //setarrisEditPanel({nPanelID: 1, isEdit: false}, {nPanelID: 2, isEdit: false});
    const [ObjExampleFile, setObjExampleFile] = useState(null);

    const [sTabID, setsTabID] = useState("Tab1");
    // const [isShowTab3, setShowTab3] = useState(false);
    // const [isShowTab4, setShowTab4] = useState(false);
    // const [isShowTab5, setShowTab5] = useState(false);
    // const [isShowTab6, setShowTab6] = useState(false);
    // const [isShowTab7, setShowTab7] = useState(false);
    // const [isShowTab8, setShowTab8] = useState(false);
    // const [isShowTab9, setShowTab9] = useState(false);

    const [isChangePanel12, setisChangePanel12] = useState(false);
    const [isChangePanel9, setisChangePanel9] = useState(false);
    const [isChangePanel6, setisChangePanel6] = useState(false);
    const [isChangePanel7, setisChangePanel7] = useState(false);

    const [nProjectSummary, setnProjectSummary] = useState(null);
    const [isSubmit, setisSubmit] = useState(false);   
    const [isChangePlan, setisChangePlan] = useState(false);
    const [isChangeUpdateProgress, setisChangeUpdateProgress] = useState(false);

    const [nRegisterTimelineType, setnRegisterTimelineType] = useState(null);
    const [isModeSecretary, setisModeSecretary] = useState(null);
    const [sPathNameBack, setsPathNameBack] = useState(null);

    const [isModalReadyPresent, setisModalReadyPresent] = useState(false); //Pop Up > พร้อมนำเสนอ   
    const [ObjDataReadyPresent, setObjDataReadyPresent] = useState(null);
    const [isModalReadyPresentComment, setisModalReadyPresentComment] = useState(false); //Pop Up > ดูรายละเอียด ที่ถูกส่งกลับมาแก้ไข  

    const [isBtnScoreSummary, setisBtnScoreSummary] = useState(false);

    const [nYearPlanID, setnYearPlanID] = useState(null);
    const [isModalPreview, setisModalPreview] = useState(false); //Pop Up > Preview  

    const [isOpenCancel, setisOpenCancel] = useState(false);
    // const [sRemark, setsRemark] = useState(null);

    const [nLogChangeID, setnLogChangeID] = useState(null);  //ขยายระยะเวลา สถานะการปรับแผนโครงการ TbLogProjectChangeStatus ค่าจะปรับเป็น NULL เมื่อมีการกดปุ่มยืนยันการปรับแผน    
    const [lstnVersionID, setlstnVersionID] = useState([]); //เวอร์ชั่น
    const [nProjectVersionID, setnProjectVersionID] = useState(0); //ID เวอร์ชั่น
    const [ObjCheckSubmitVersion, setObjCheckSubmitVersion] = useState({
        isPanel9: false,
        sWarningPanel9: null,
        isWorkPlan: false,
        sWarningWorkPlan: null,
        isSpendingPlan: false,
        sWarningSpendingPlan: null,
    }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    //#endregion
    
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            nProjectVersionID: null,
        }
    });

    // const ObjParamPath = useMemo(() => {
    //     const nID = Convert.StringToInt(new URLSearchParams(location.search).get("sID"));
    //     const sMode = new URLSearchParams(location.search).get("sMode"); //View | null | Edit ต้องจับจากสถานะ
    //     const nRegisterTimelineType = Convert.StringToInt(new URLSearchParams(location.search).get("sRegisterTimelineType")); //EnumRegisterTimelineType
    //     const sModeSecretary = new URLSearchParams(location.search).get("sModeSecretary"); //True เลขา | False ไม่ใช่เลขา
    //     const sPathNameBack = new URLSearchParams(location.search).get("sPathNameBack"); //กรณีมาจากหน้าอื่นๆ จะให้กลับไปหน้าก่อนหน้า 
    //     return { nID, sMode, nRegisterTimelineType, sModeSecretary, sPathNameBack }
    // }, [location.search])

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth",});
        let nID = 0;
        if (location?.state) {
            nID = Convert.StringToInt(location.state["sID"]);
            let sMode = location.state["sMode"]; //View | null | Edit ต้องจับจากสถานะ
            let nRegisterTimelineType = Convert.StringToInt(location.state["sRegisterTimelineType"]); //EnumRegisterTimelineType
            let sModeSecretary = location.state["sModeSecretary"]; //True เลขา | False ไม่ใช่เลขา
            let sPathNameBack = location.state["sPathNameBack"]; //กรณีมาจากหน้าอื่นๆ จะให้กลับไปหน้าก่อนหน้า            

            setnProjectID(nID);
            setsMode(sMode);
            setnRegisterTimelineType(nRegisterTimelineType);
            setisModeSecretary(sModeSecretary ?? null);
            setsPathNameBack(sPathNameBack ?? null);
            // setisPermission(sMode !== "View");
            setisPermission(sMode === "Edit" ? true : false); //(sMode === "Update" ? false : false)

            // setisFastTrack(nRegisterTimelineType === EnumRegisterTimelineType.FastTrack);
            // nRegisterTimelineID
        }
        // else {
        //     GetMenuPermission(AxiosFn, setisPermission, DialogFn);
        // }
        GetFormInitialProject(nID);
    }, []);

    useEffect(() => {
        //isPermission && nProjectID !== 0 && (isSubmit || isGetFromID)
        if ((isPermission && nProjectID !== 0) || isGetFromID) handleGetFormProjectID(nProjectID);
    }, [isPermission, nProjectID, isGetFromID, isSubmit]);

    useEffect(() => {
        //ทำมาเพราะว่า เวลาเพิ่มข้อมูลใหม่ครั้งแรกและกดบันทึก ตาม Panel และกดรีหน้าจอใหม่ ของข้อมูล nProjectID หายไปเลยต้อง Set location?.state ใหม่หลังจาก มีการไปสร้างข้อมูล Project
        if (nProjectID !== 0) {
            // let sPathName = Router.GetCurrentRoute();
            if (location?.state === null) {
                navigate(null,
                    {
                        state:
                        {
                            sID: nProjectID + "",
                            sMode: "Edit", //ความจริงเป็น Add //View | null | Edit ต้องจับจากสถานะ
                            sRegisterTimelineType: (isFastTrack ? EnumRegisterTimelineType.FastTrack : EnumRegisterTimelineType.Normal),
                            nRegisterTimelineID: nRegisterTimelineType,
                            sModeSecretary: false, //True เลขา | False ไม่ใช่เลขา
                            sPathNameBack: sPathNameBack, //กรณีมาจากหน้าอื่นๆ จะให้กลับไปหน้าก่อนหน้า         
                        }
                    }
                );
            }
        }
    }, [nProjectID]);

    const GetFormInitialProject = (nID) => {
        AxiosFn.Get(ApiProject.GetFormInitialProject, { nProjectID: nID }, (result) => {
            setObjExampleFile(result.ObjExampleFile);
            setisFastTrack(result.isFastTrack);
            setisRequester(result.isRequester);
            setisSecretary(result.isSecretary);
            // setisSubCommittee(result.isSubCommittee);
            // setlstProjectCheckList(result.lstProjectCheckList);

            setnStatusID(result.nStatusID); //TbProject.nStatusID
            setnProgressStatusID(result.nProgressStatusID); //TbProject.nProgressStatusID
            setnStatusUpdateProgressID(result.nStatusUpdateProgressID); //TprojectUpdateProgress.nStatus
            setObjStepFlowProject(result.ObjStepFlowProjectBtn);
            console.log("ObjStepFlowProject", result.ObjStepFlowProjectBtn);

            setnLogChangeID(result.nLogChangeID); //ขยายระยะเวลา สถานะการปรับแผนโครงการ TbLogProjectChangeStatus ค่าจะปรับเป็น NULL เมื่อมีการกดปุ่มยืนยันการปรับแผน
            setlstnVersionID(result.lstnVersionID); //เวอร์ชั่น 
            form.setValue("nProjectVersionID", result.lstnVersionID.length > 0 ? 999999 : null);
            console.log("GetFormInitialProject ", result);

            if (nID) setisGetFromID(true); //handleGetFormProjectID(nID);
        });
    }

    const handleBack = () => {
        let sNameBack = "/Project";
        let sPathName = Router.GetCurrentRoute();
        if (sPathName === "/projectsrequestingfrom") sNameBack = "/ProjectList";
        navigate(sPathNameBack !== null ? sPathNameBack : sNameBack);
    }

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID, sMessage: string, sRemark: string = null) => {
        let param = {
            nProjectID: nProjectID,
            isFastTrack: isFastTrack,
            sLocation: location.pathname,

            nSaveModeProject: nModeID,
            nStatusID: nStatusID,
            sRemark: sRemark,
        };
        // DialogFn.Submit(nModeID === EnumSaveModeProject.Cancel ? I18n.SetText("Message.ConfirmCancel", I18NextNs.labelComponent): I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
        DialogFn.Submit(("คุณต้องการ" + sMessage + "หรือไม่ ?"), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProject, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    // DialogFn.Success(nModeID === EnumSaveModeProject.Cancel ? I18n.SetText("Message.CancelComplete", I18NextNs.labelComponent) : I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => { handleBack(); });
                    DialogFn.Success((sMessage + "สำเร็จ"), () => { handleBack(); });                
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    }

    const handleGetFormProjectID = (nID) => {
        DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID, { nProjectID: nID }, (result) => {
            DialogFn.UnBlockUI();
            setisSend(result.objResult.isSend);
        });
    };

    //#region ส่งนำเสนอ | ยืนยันการแก้ไข เช็คเงื่อนไขกรณีข้อมูลที่อยู่ บันทึกพร้อมส่ง และมีการแก้ข้อมูลไป และมีความสัมพันธ์ Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
    const [sCheckErrorMode, setsCheckErrorMode] = useState(null);
    useEffect(() => {
        //handleSubmit >> (isBtn_SendAnOffer //Requester >> ส่งข้อเสนอ) && (isBtn_Confirm //Requester Confirm >> ยืนยัน < การแก้ไข)
        if (sCheckErrorMode !== null) {
            if (ObjCheckSubmitVersion?.isPanel9 === true) {
                if (ObjCheckSubmitVersion?.isWorkPlan === false) document.getElementById("btnCheck_WorkPlan_ChangeStatus").click();
                if (ObjCheckSubmitVersion?.isSpendingPlan === false) document.getElementById("btnCheck_SpendingPlan_ChangeStatus").click();
            }

            if (ObjCheckSubmitVersion?.isPanel9 === true && ObjCheckSubmitVersion?.isWorkPlan === true && ObjCheckSubmitVersion?.isSpendingPlan === true) 
            {
                if (ObjCheckSubmitVersion?.sWarningPanel9 !== null || ObjCheckSubmitVersion?.sWarningWorkPlan !== null || ObjCheckSubmitVersion?.sWarningSpendingPlan !== null) {
                    DialogFn.Warning((ObjCheckSubmitVersion?.sWarningPanel9 ?? "") + (ObjCheckSubmitVersion?.sWarningWorkPlan ?? "") + (ObjCheckSubmitVersion?.sWarningSpendingPlan ?? ""));
                } else {
                    if (sCheckErrorMode === "SendAnOffer") {
                        handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_1, I18n.SetText("Button.SendAnOffer", I18NextNs.labelComponent));
                    } else if (sCheckErrorMode === "Confirm") {
                        handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_4, I18n.SetText("Button.Confirm", I18NextNs.labelComponent));
                    }               
                }
                setObjCheckSubmitVersion({
                    isPanel9: false,
                    sWarningPanel9: null,
                    isWorkPlan: false,
                    sWarningWorkPlan: null,
                    isSpendingPlan: false,
                    sWarningSpendingPlan: null,
                }); //Error ของ (Panel 9 || WorkPlan 2/1 || SpendingPlan 2/2)
                setsCheckErrorMode(null);
            }
        }
    }, [sCheckErrorMode, ObjCheckSubmitVersion]);
    //#endregion
  
    return (
        <>
        <ProjectContext.Provider
            value={useMemo(() => ({
                nProjectID: nProjectID,
                setnProjectID: setnProjectID,
                isFastTrack: isFastTrack,
                isPermission: isPermission,
                ObjProjectRequest: ObjProjectRequest,
                arrisEditPanel: arrisEditPanel,
                setarrisEditPanel: setarrisEditPanel,
                nStatusID: nStatusID,
                ObjExampleFile: ObjExampleFile,
                isChangePanel12: isChangePanel12,
                setisChangePanel12: setisChangePanel12,
                isChangePanel9: isChangePanel9,
                setisChangePanel9: setisChangePanel9,
                nProjectSummary: nProjectSummary,
                setnProjectSummary: setnProjectSummary,
                isChangePanel6: isChangePanel6,
                setisChangePanel6: setisChangePanel6,
                isChangePanel7: isChangePanel7,
                setisChangePanel7: setisChangePanel7,
                isSubmit: isSubmit,
                setisSubmit: setisSubmit,
                ObjStepFlowProject: ObjStepFlowProject,
                isModeSecretary: isModeSecretary,
                sMode,
                setisBtnScoreSummary,
                nYearPlanID,
                setnYearPlanID,
                isModalPreview,
                setisModalPreview,
                sTabID,
                isChangePlan, 
                setisChangePlan,
                nProjectVersionID,
                nLogChangeID,
                setnLogChangeID,
                ObjCheckSubmitVersion,
                setObjCheckSubmitVersion,
                nProgressStatusID,
                nStatusUpdateProgressID,
                sPathNameBack,
                isChangeUpdateProgress,
                setisChangeUpdateProgress,
            }), 
            [
                nProjectID,
                setnProjectID,
                isFastTrack,
                isPermission,
                ObjProjectRequest,
                arrisEditPanel,
                setarrisEditPanel,
                nStatusID,
                ObjExampleFile,
                isChangePanel12,
                setisChangePanel12,
                isChangePanel9,
                setisChangePanel9,
                nProjectSummary,
                setnProjectSummary,
                isChangePanel6,
                setisChangePanel6,
                isSubmit,
                setisSubmit,
                ObjStepFlowProject,
                isModeSecretary,
                sMode,
                setisBtnScoreSummary,
                nYearPlanID,
                setnYearPlanID,
                isModalPreview,
                setisModalPreview,
                sTabID,
                isChangePlan, 
                setisChangePlan,
                nProjectVersionID,
                nLogChangeID,
                setnLogChangeID,
                ObjCheckSubmitVersion,
                setObjCheckSubmitVersion,
                nProgressStatusID,
                nStatusUpdateProgressID,
                sPathNameBack,
                isChangeUpdateProgress,
                setisChangeUpdateProgress,
                isChangePanel7,
                setisChangePanel7,
            ])} 
        >
            <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '2%', }}>
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '3%', paddingLeft: '2%' }}>
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '3%', }}>
                        <StepperProject
                            // arrStepper={[
                            //     { sLabel: "1. ยื่นข้อเสนอโครงการ", sActionBy: "" },
                            //     { sLabel: "2. ตรวจสอบข้อเสนอโครงการ", sActionBy: "" },
                            //     { sLabel: "3. กลั่นกรองฯ ข้อเสนอโครงการ", sActionBy: "" },
                            //     { sLabel: "4. พิจารณาอนุมัติโครงการ", sActionBy: "" }
                            // ]}
                            arrStepper={ObjStepFlowProject?.lstStepper ?? []}
                            nActiveStep={ObjStepFlowProject?.nActiveStepper ?? 0}
                            nStatusID={nStatusID}
                        />
                    </Grid>
                    {((lstnVersionID || []).length > 0 && (nLogChangeID === null || !isPermission)) &&
                        <Grid container spacing={1} justifyContent={"end"} alignItems={"center"} style={{ paddingBottom: '1%', }}>
                            <FormProvider {...form}>
                                <Grid item xs={4} md={1.5}>
                                    <SelectItem
                                        id={"nProjectVersionID"}
                                        name={"nProjectVersionID"}
                                        label={`เวอร์ชัน`}
                                        required={false}
                                        options={lstnVersionID}
                                        IsClearable={true}
                                        onChange={(e) => {
                                            let nValue = Convert.StringToIntOrNull(e.value);
                                            setnProjectVersionID(nValue !== 999999 ? nValue : null);
                                        }}
                                    />
                                </Grid>
                            </FormProvider>
                        </Grid>
                    }
                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                        <Tabs id={"TabsKth1"} defaultTab={sTabID} onTabChange={(e) => { setsTabID(e); }}>
                            <TabItem
                                key={"Tab1"}
                                id={"Tab1"}
                                sBackgroundTab={sBackgroundTab}
                                sBackgroundTabActive={sBackgroundTabActive}
                            >กท. 1</TabItem>
                            <TabItem
                                key={"Tab2"}
                                id={"Tab2"}
                                sBackgroundTab={sBackgroundTab}
                                sBackgroundTabActive={sBackgroundTabActive}
                            // isDisabled={nProjectID === 0}
                            >กท. 2</TabItem>
                            {ObjStepFlowProject?.isShowTab3 &&
                                <TabItem
                                    key={"Tab3"}
                                    id="Tab3"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >ลงคะแนนข้อเสนอโครงการ</TabItem>}
                            {ObjStepFlowProject?.isShowTab4 &&
                                <TabItem
                                    key={"Tab4"}
                                    id="Tab4"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >สรุปคะแนน</TabItem>}
                            {ObjStepFlowProject?.isShowTab5 && 
                                <TabItem 
                                    key={"Tab5"}
                                    id="Tab5" 
                                    sBackgroundTab={sBackgroundTab} 
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >บันทึกมติ</TabItem>}
                            {ObjStepFlowProject?.isShowTab6 &&
                                <TabItem
                                    key={"Tab6"}
                                    id="Tab6"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >กท. 3/1</TabItem>}
                            {ObjStepFlowProject?.isShowTab7 &&
                                <TabItem
                                    key={"Tab7"}
                                    id="Tab7"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >กท. 3/2</TabItem>}
                            {ObjStepFlowProject?.isShowTab8 &&
                                <TabItem
                                    key={"Tab8"}
                                    id="Tab8"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >นำเสนอวิชาการ/ตีพิมพ์</TabItem>}
                            {ObjStepFlowProject?.isShowTab9 &&
                                <TabItem
                                    key={"Tab9"}
                                    id="Tab9"
                                    sBackgroundTab={sBackgroundTab}
                                    sBackgroundTabActive={sBackgroundTabActive}
                                // isDisabled={nProjectID === 0}
                                >สื่อเผยแพร่และประชาสัมพันธ์</TabItem>} {/* นำเสนอวิชาการ/ตีพิมพ์ */}
                            <TabContent id={"TabContentKth1"}>
                                <TabPanel id="Tab1">
                                    {/* กท. 1 Panel 0 - 12 */}
                                    <RequestPanel />
                                </TabPanel>
                                <TabPanel id="Tab2">
                                    {/* กท. 2 > แผนปฎิบัติงาน 2/1 && แผนการใช้จ่ายเงิน 2/2 */}
                                    <RequestPlan/>
                                </TabPanel>
                                {ObjStepFlowProject?.isShowTab3 &&
                                    <TabPanel id="Tab3">
                                        {/* ลงคะแนนข้อเสนอโครงการ */}
                                        <ProjectScoringCriteria />
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab4 &&
                                    <TabPanel id="Tab4">
                                        {/* สรุปคะแนน */}
                                        <ProjectScoreSummary />
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab5 &&
                                    <TabPanel id="Tab5">
                                        {/* บันทึกมติ */}
                                        <ProjectRecordResolution />
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab6 &&
                                    <TabPanel id="Tab6">
                                    {/* กท. 3/1 */}
                                    <UpdateProgressPlan/>
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab7 &&
                                    <TabPanel id="Tab7">
                                    {/* กท. 3/2 */}
                                        <CloseProject />
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab8 &&
                                    <TabPanel id="Tab8">
                                    {/* นำเสนอวิชาการ/ตีพิมพ์ 40(3) */}
                                        <Present403 />
                                    </TabPanel>
                                }
                                {ObjStepFlowProject?.isShowTab9 &&
                                    <TabPanel id="Tab9">
                                    {/* นำเสนอวิชาการ/ตีพิมพ์ 40(4) */}
                                        <Present404 />
                                    </TabPanel>
                                }
                            </TabContent>
                        </Tabs>
                    </Grid>

                    {/* ความคิดเห็น (เลขาโครงการ) */}
                    {((isModeSecretary === true && isSecretary && nStatusID >= EnumProjectStatusID.nStatusID_2 && sTabID === "Tab1") || (nStatusID >= EnumProjectStatusID.nStatusID_2 && sTabID === "Tab1")) && // nStatusID >= EnumProjectStatusID.nStatusID_3
                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }} alignItems={'center'}>
                            <Grid item>
                                <Typography variant='body1' fontWeight="bold">ความคิดเห็น (เลขาโครงการ)</Typography>
                            </Grid>
                            <Grid item>
                                <BtnDes id={"btnReadyPresentComment"} txt={I18n.SetText("Button.Comment", I18NextNs.labelComponent)} onClick={(e) => { setisModalReadyPresentComment(true); }} />
                                <ModalReadyPresent
                                    isOpen={isModalReadyPresentComment}
                                    setIsOpen={setisModalReadyPresentComment}
                                    ObjData={{
                                        nProjectID: nProjectID,
                                        isEdit: false,
                                        isPermission: false,
                                        // isFastTrack: isFastTrack,
                                        sMessage: I18n.SetText("Button.Comment", I18NextNs.labelComponent),
                                        isSecretary: isSecretary,
                                    }} 
                                />
                            </Grid>
                        </Grid>
                    }

                    {/* เลขาขยายระยะเวลาโครงการ */}
                    {(isModeSecretary === true && isSecretary && nStatusID === EnumProjectStatusID.nStatusID_11 && (sTabID === "Tab1" || sTabID === "Tab2") && 
                     (nProgressStatusID !== EnumProjectStatusID.nStatusID_35 && nProgressStatusID !== EnumProjectStatusID.nStatusID_25 && nProgressStatusID !== EnumProjectStatusID.nStatusID_26 && nProgressStatusID !== EnumProjectStatusID.nStatusID_28)) && 
                        <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }} alignItems={'center'}>
                            <ProjectChangeStatus /> 
                        </Grid>
                    }

                    <Grid item xs={12} md={12} container spacing={1} justifyContent="center" style={{ paddingBottom: '2%', }}>
                        <Grid item>
                            <BtnBack id={"btnBack"} onClick={() => handleBack()} />
                        </Grid>
                        {/* 
                            ObjStepFlow.isBtn_CancelRequest = false; //Cancel Request >> ยกเลิกคำขอ
                            ObjStepFlow.isBtn_Preview = true; //Preview กท 2/1 2/2 >> ดูตัวอย่าง กท 2/1 2/2
                            ObjStepFlow.isBtn_SendAnOffer = isRequester ? true : false; //Requester >> ส่งข้อเสนอ
                            ObjStepFlow.isBtn_ReadyPresent = false; //เลขา >> พร้อมนำเสนอ
                            ObjStepFlow.isBtn_SendEdit = false; //เลขา >> ส่งกลับแก้ไข
                            ObjStepFlow.isBtn_Confirm = false; //Requester Confirm >> ยืนยัน
                            ObjStepFlow.isBtn_CheckDocAccordingResolutionPass = false; //เลขา >> ตรวจสอบเอกสารตามมติ (ผ่าน)
                            ObjStepFlow.isBtn_RecordScore = false; //อนุกรรมการ >> บันทึกคะแนน
                            ObjStepFlow.isBtn_ScoreSummary = false; //เลขา >> สรุปคะแนน 
                            ObjStepFlow.isBtn_Save = false; //Save >> บันทึก (อนุมัติ | ไม่อนุมัติ)
                            ObjStepFlow.isBtn_ConfirmChangeStatus = false; //เลขา >> ยืนยัน การปรับแผนโครงการ (การขยายระยะเวลาโครงการ)
                        */}
                        {(ObjStepFlowProject?.isBtn_Preview === true && sTabID === "Tab2") &&
                            <Grid item>
                                <BtnPreviewForm
                                    id={"btnPreview"}
                                    txt={I18n.SetText("Button.Preview", I18NextNs.labelComponent)}
                                    onClick={() => { setisModalPreview(true); }}
                                />
                            </Grid>
                        }
                        {(isPermission || sMode === "Update") &&
                            <>
                                {ObjStepFlowProject?.isBtn_CancelRequest === true &&
                                    <Grid item>
                                        <BtnReject 
                                            id={"btnCancelRequest"} 
                                            IsDisabled={!isPermission} 
                                            txt={I18n.SetText("Button.CancelReques", I18NextNs.labelComponent)} 
                                            onClick={(e) => { 
                                                setisOpenCancel(true);
                                                // handleSubmit(EnumSaveModeProject.Cancel, EnumProjectStatusID.nStatusID_31);
                                            }} 
                                        />
                                        <ModalProjectCancel isOpenCancel={isOpenCancel} setisOpenCancel={setisOpenCancel} handleSubmit={handleSubmit} />
                                    </Grid>
                                }
                                {ObjStepFlowProject?.isBtn_SendAnOffer === true &&
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnSendAnOffer"} 
                                            IsDisabled={isSend || !isPermission}
                                            // IsDisabled={((isSend === false && isSendError === true) ? true : isSend) || !isPermission}
                                            txt={I18n.SetText("Button.SendAnOffer", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                // handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_1, I18n.SetText("Button.SendAnOffer", I18NextNs.labelComponent));
                                                
                                                document.getElementById("btnCheck_Panel9_ChangeStatus").click();
                                                setsCheckErrorMode("SendAnOffer");
                                            }} 
                                        />
                                    </Grid> 
                                }    
                                {(ObjStepFlowProject?.isBtn_ReadyPresent === true && isModeSecretary === true) && 
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnReadyPresent"} 
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            IsDisabled={!isPermission} 
                                            txt={I18n.SetText("Button.ReadyPresent", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                setisModalReadyPresent(true);
                                                setObjDataReadyPresent({
                                                    nProjectID: nProjectID,
                                                    isEdit: false,
                                                    isPermission: true,
                                                    isFastTrack: false,
                                                    sMessage: I18n.SetText("Button.ReadyPresent", I18NextNs.labelComponent),
                                                    isSecretary: isSecretary,
                                                });
                                                //handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_2)
                                            }} 
                                        />
                                    </Grid> 
                                }
                                {(ObjStepFlowProject?.isBtn_SendEdit === true && isModeSecretary === true) &&
                                    <Grid item>
                                        <BtnEdit 
                                            id={"btnSendEdit"} 
                                            IsDisabled={!isPermission} 
                                            txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                setisModalReadyPresent(true);
                                                setObjDataReadyPresent({
                                                    nProjectID: nProjectID,
                                                    isEdit: true,
                                                    isPermission: true,
                                                    isFastTrack: false,
                                                    sMessage: I18n.SetText("Button.SendEdit", I18NextNs.labelComponent),
                                                    isSecretary: isSecretary,
                                                });
                                                // handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_3)                                            
                                            }} 
                                        />
                                    </Grid> 
                                }
                                {(ObjStepFlowProject?.isBtn_Confirm === true && isModeSecretary !== true) &&
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnConfirm"}
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            IsDisabled={!isPermission}
                                            // IsDisabled={!isPermission || isSendError}
                                            txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                // handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_4, I18n.SetText("Button.Confirm", I18NextNs.labelComponent));

                                                document.getElementById("btnCheck_Panel9_ChangeStatus").click();
                                                setsCheckErrorMode("Confirm");
                                            }} 
                                        />
                                    </Grid> 
                                }     
                                {(ObjStepFlowProject?.isBtn_CheckDocAccordingResolutionPass === true && isModeSecretary === true) && 
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnCheckDocAccordingResolutionPass"}
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            IsDisabled={!isPermission} 
                                            txt={I18n.SetText("Button.CheckDocAccordingResolutionPass", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_5, "ส่ง" + I18n.SetText("Button.CheckDocAccordingResolutionPass", I18NextNs.labelComponent) + " ");
                                            }} 
                                        />
                                    </Grid> 
                                }
                                {ObjStepFlowProject?.isBtn_RecordScore === true && // && isModeSecretary === true
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnRecordScore"}
                                            // IsDisabled={!isPermission || sMode !== "Update"} 
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            txt={I18n.SetText("Button.RecordScore", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                document.getElementById("BtnScore").click();
                                                // sTabID === "Tab3"
                                                // handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_6);
                                                //// EnumProjectStatusID.nStatusID_6 || (คนสุดท้ายต้อง) EnumProjectStatusID.nStatusID_7
                                            }}
                                        />
                                    </Grid>
                                }
                                {ObjStepFlowProject?.isBtn_ScoreSummary === true &&
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnScoreSummary"} 
                                            IsDisabled={!isBtnScoreSummary} 
                                            txt={I18n.SetText("Button.ScoreSummary", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_8, I18n.SetText("Button.ScoreSummary", I18NextNs.labelComponent)); 
                                            }} 
                                        />
                                    </Grid> 
                                }
                                {ObjStepFlowProject?.isBtn_Save === true && 
                                    <>
                                        <Grid item>
                                            <BtnDownload 
                                                id={"BtnDraft"} 
                                                IsDisabled={!isPermission}
                                                bgcolor={"#30d7b9"}
                                                bgcolorHover={"#3abfa7"}
                                                txt={I18n.SetText("Button.DraftResultLetter", I18NextNs.labelComponent)} 
                                                onClick={(e) => {
                                                    // handleSubmit(EnumSaveModeProject.Draft, EnumProjectStatusID.nStatusID_10);
                                                    document.getElementById("BtnDraft_ResultLetter").click();
                                                }}                                                
                                            />
                                        </Grid> 
                                        <Grid item>
                                            <BtnSend 
                                                id={"BtnSave"} 
                                                IsDisabled={!isPermission} 
                                                txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)} 
                                                bgcolor={"#33a64c"}
                                                bgcolorHover={"#33a64c"}
                                                onClick={(e) => {
                                                    // handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_11);
                                                    {/* (อนุมัติ) EnumProjectStatusID.nStatusID_11 || (ไม่อนุมัติ) EnumProjectStatusID.nStatusID_12 */}
                                                    document.getElementById("BtnSubmit_ResultLetter").click();
                                                }}                                                
                                            />
                                        </Grid> 
                                    </>
                                }
                                {(ObjStepFlowProject?.isBtn_SendProposal === true && isModeSecretary === true) &&
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnSendProposal"} 
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            IsDisabled={!isPermission} 
                                            txt={I18n.SetText("Button.SendProposal", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                setisModalReadyPresent(true);
                                                setObjDataReadyPresent({
                                                    nProjectID: nProjectID,
                                                    isEdit: false,
                                                    isPermission: true,
                                                    isFastTrack: true,
                                                    sMessage: I18n.SetText("Button.SendProposal", I18NextNs.labelComponent),
                                                    isSecretary: isSecretary,
                                                });
                                                //handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_10)
                                            }} 
                                        />
                                    </Grid> 
                                }
                                {((ObjStepFlowProject?.isBtn_ConfirmChangeStatus === true && isModeSecretary === true) || (nLogChangeID !== null && isModeSecretary === true && isSecretary && nStatusID === EnumProjectStatusID.nStatusID_11)) &&
                                    <Grid item>
                                        <BtnSend 
                                            id={"btnConfirmChangeStatus"} 
                                            bgcolor={"#33a64c"} 
                                            bgcolorHover={"#33a64c"} 
                                            IsDisabled={!isPermission} // || sWarningCheckSubmitVersion !== null
                                            txt={I18n.SetText("Button.ConfirmChangeStatus", I18NextNs.labelComponent)} 
                                            onClick={(e) => {
                                                document.getElementById("btnCheck_Panel9_ChangeStatus").click();
                                                // document.getElementById("btnCheck_WorkPlan_ChangeStatus").click();
                                                // document.getElementById("btnCheck_SpendingPlan_ChangeStatus").click();

                                                // document.getElementById("BtnConfirmVersion").click();
                                            }} 
                                        />
                                    </Grid> 
                                }
                            </>
                        }
                    </Grid>
                </Grid>

                {nProjectID !== 0 && nStatusID !== EnumProjectStatusID.nStatusID_0 && <LogHistory nRefID={nProjectID} nMode={EnumLogHistoryMode.Project} />}
                <ModalReadyPresent isOpen={isModalReadyPresent} setIsOpen={setisModalReadyPresent} ObjData={ObjDataReadyPresent} /> {/* ObjData={ObjDataReadyPresent} || nProjectID={nProjectID} isEdit={false} isPermission={true} */}
            </Grid>
        </ProjectContext.Provider>

        <ScrollToTop>
            <Fab
                color="error"
                size="large"
                sx={{
                    flexDirection: "column",
                    borderRadius: "16px",
                    width: "35px",
                    height: "70px",
                    textAlign: "center",
                    lineHeight: "1",
                    fontSize: "13px",
                    backgroundColor: "#ff0000"
                }}
            >
                <HiOutlineArrowNarrowUp size="25" />
                <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                    UP
                </span>
            </Fab>
        </ScrollToTop>
        </>
    )
}
export default ProjectRequestFrom;
export { ProjectContext };


const ScrollToTop = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 300,
    });

    const handleClick = (event) => {
        window.scrollTo({ top: 0, behavior: `smooth` })
    };

    return (
        <Zoom in={trigger}>
            <div
                onClick={handleClick}
                role="presentation"
                style={{
                    position: "fixed",
                    bottom: "12px",
                    right: "15px",
                    width: "46.7px",
                    height: "87.5px",
                }}
            >
                {children}
            </div>
        </Zoom>
    );
};